import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { DataroomState, DataroomStore } from './dataroom.store';

@Injectable({ providedIn: 'root' })
export class DataroomQuery extends QueryEntity<DataroomState> {
  constructor(protected store: DataroomStore) {
    super(store);
  }
}
